import { create } from '@terminal/utils/store/createStore';

interface ScheduleDrawerState {
  isOpen: boolean;
}

interface ScheduleDrawerActions {
  open: () => void;
  close: () => void;
}

type ScheduleDrawerStore = ScheduleDrawerState & ScheduleDrawerActions;

export const useScheduleDrawer = create<ScheduleDrawerStore>(set => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
